module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16.0b76d1d1.jpg";